
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'message-text': {'color': `#ffffff`,},'message-icon': {'color': `#ffffff`,},'buttonContainer': {'display': `flex`,'flexDirection': `row`,'justifyContent': `flex-end`,},'cancelButton': {'marginRight': `15px`,},'input': {'backgroundColor': `#4b4b4b`,'color': `#ffffff`,},'input-placeholder': {'color': `#ffffff`,},'input-container': {'borderColor': `#585858`,},'googlePayContainer': {'padding': `0.25rem 0`,},
        
      };
    };
  